import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const EmailIconOpen = ({
  width = 24,
  height = 24,
  stroke = '#A0A4A8',
  strokeWidth = 1.2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_2314_24280)">
      <path
        d="M12.0098 0.611328C13.0995 0.61376 14.1476 1.01802 14.9551 1.74219L15.1133 1.8916L15.1201 1.89844L22.0439 8.53418C22.4713 8.94553 22.811 9.43891 23.0439 9.98438C23.2479 10.4619 23.3662 10.9709 23.3936 11.4883L23.4004 11.7109V19.001C23.3988 20.1674 22.9342 21.2855 22.1094 22.1104C21.2844 22.9353 20.1657 23.4 18.999 23.4014H5.00098C3.83426 23.4 2.71562 22.9353 1.89062 22.1104C1.06567 21.2854 0.601007 20.1667 0.599609 19V11.7109C0.601195 11.1175 0.722162 10.5302 0.955078 9.98438C1.18787 9.43898 1.52811 8.94569 1.95508 8.53418L8.89453 1.88281L8.89551 1.88379L8.90039 1.87793C9.73016 1.06399 10.8474 0.608857 12.0098 0.611328ZM15.1133 17.1104C14.2849 17.9306 13.1658 18.3916 12 18.3916C10.8342 18.3916 9.71509 17.9306 8.88672 17.1104L1.69141 9.91504L1.4707 11.0127C1.42486 11.2409 1.4016 11.4733 1.40039 11.7061V19.001C1.40039 19.9557 1.77901 20.8717 2.4541 21.5469C3.12923 22.222 4.04522 22.6016 5 22.6016H19C19.9548 22.6016 20.8708 22.222 21.5459 21.5469C22.221 20.8717 22.5996 19.9557 22.5996 19.001V11.7061C22.5984 11.4733 22.5751 11.2409 22.5293 11.0127L22.3086 9.91504L15.1133 17.1104ZM12.0137 1.40625C11.0596 1.40267 10.1431 1.7767 9.46387 2.44629L2.7002 8.92578L2.25684 9.34961L2.69043 9.7832L9.45508 16.5469L9.45996 16.5527L9.46484 16.5576C10.1481 17.2089 11.056 17.5723 12 17.5723C12.944 17.5723 13.8519 17.2089 14.5352 16.5576L14.54 16.5527L14.5449 16.5469L21.3086 9.7832L21.7412 9.34961L21.2988 8.92578L14.5615 2.47168H14.5625C13.8877 1.79285 12.9709 1.40988 12.0137 1.40625Z"
        fill="#52575C"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </g>
    <defs>
      <clipPath id="clip0_2314_24280">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
